import React, { useEffect } from 'react';
import { create } from 'jss';
import jssPluginExtend from 'jss-plugin-extend';
import { IntlProvider } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import JssProvider from 'react-jss/lib/JssProvider';
import CssBaseline from '@material-ui/core/CssBaseline';
import { MuiThemeProvider, jssPreset } from '@material-ui/core/styles';
import { ConnectedRouter } from 'connected-react-router';
import Grid from '@material-ui/core/Grid';

import { authInitRequest } from 'yeself-client-common/security/SecurityAction';

import PrivateRoute from 'yeself-client-common/security/components/PrivateRoute';

import Footer from 'Console/components/Footer';
import { FooterColorProvider } from 'Console/components/FooterColourContext';
import NotificationList from 'Console/components/common/notifications/NotificationList';
import SplashView from 'Console/components/SplashView';

import Application from 'Console/containers/Application';
import { ROUTES } from 'Console/constants/routes';
import { selectConsoleLanguageCode } from 'Console/data/app/selectors';
import translationLoader from 'Console/utils/translationLoader';
import { MiUiTheme } from 'Console/utils/styleUtils';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';

const jss = create({
    plugins: [...jssPreset().plugins, jssPluginExtend()],
});

const AppWrapper = ({ history }) => {
    const dispatch = useDispatch();

    const locale = useSelector(selectConsoleLanguageCode);

    useEffect(() => {
        dispatch(authInitRequest({ loginRequired: true, loginFromIFrame: false }));
    }, [dispatch]);

    const { language, messages } = translationLoader(locale);

    return (
        <IntlProvider locale={language} key={language} messages={messages}>
        <JssProvider jss={jss}>
            <MuiThemeProvider theme={MiUiTheme}>
                <CssBaseline />
                <ConnectedRouter history={history}>
                    <FooterColorProvider>
                        <Grid
                            style={{ minHeight: '100vh' }}
                            container
                            direction="column"
                            justify="space-around"
                        >
                            <PrivateRoute
                                path={ROUTES.BASE}
                                component={Application}
                                loading={SplashView}
                            />
                            <NotificationList />
                            <Footer />
                        </Grid>
                    </FooterColorProvider>
                </ConnectedRouter>
            </MuiThemeProvider>
        </JssProvider>
    </IntlProvider>
    );
};

export default AppWrapper;
